import TypeformIcon from './platforms/component-lib.esm30.js';
import JotformIcon from './platforms/component-lib.esm29.js';
import DynamicFormIcon from './component-lib.esm66.js';
const FORM_ICONS = {
  TypeformIcon,
  JotformIcon,
  DynamicFormIcon
};
export { FORM_ICONS };